import React, { ReactNode, useEffect } from "react"
import useMediaQuery from "@material-ui/core/useMediaQuery"
import clsx from "clsx"

import Container from "@ecom/ui/components/Container"
import Button from "@material-ui/core/Button"
import Img from "./Img"
import ImgFish from "./ImgFish"
import ImgGetHalva from "./ImgGetHalva"
import ImgPinkGetHalva from "./ImgPinkGetHalva"

import * as styles from "./banner.module.scss"
import { useObserver } from "../../../hooks/useObserver"
import {
  handleClickBanner,
  handleClickStickyBtn,
} from "../../../helpers/WatcherDL/utils/handleClickBanner"

type BannerProps = {
  buttonText?: string
  title?: string | ReactNode
  titleMob?: string | ReactNode
  description?: string
  orderNum?: string
  variantStyle?: string
  variantImg?: "isPkw" | "isHalva" | "isGetHalva" | "isPinkGetHalva"
}

const defaultTitleMob = `
Рассрочка* до 24 мес. </br>
по карте «Халва»
`

const defaultTitle = `
Рассрочка* до 24 месяцев </br>
по карте «Халва»
`

const defaultDescription = `
— До 5% к ставке вклада
<br />
— Кэшбэк до 10%
<br />
— Обслуживание 0 ₽ 
`

export function Banner({
  buttonText = "Оформить карту",
  title = defaultTitle,
  titleMob = defaultTitleMob,
  description = defaultDescription,
  orderNum,
  variantStyle = "default",
  variantImg = "isHalva",
}: BannerProps) {
  useEffect(() => {
    document.body.style.display = "block"
  }, [])
  const isMob = useMediaQuery("(max-width:599.5px)")
  const isVisible = useObserver([
    "app",
    "calculatorCard",
    "reviewCard",
    "moreBenefits",
    "formPkw",
    "interactive_benefits_block",
    "refinBlock",
    "calculator",
  ])

  const finalTitle = isMob ? titleMob : title

  const showImage = () => {
    switch (variantImg) {
      case "isPkw":
        return <ImgFish alt="bg image" className={styles.img} />
      case "isGetHalva":
        return <ImgGetHalva alt="bg image" className={styles.img} />
      case "isPinkGetHalva":
        return <ImgPinkGetHalva alt="bg image" className={styles.img} />
      default:
        return <Img alt="bg image" className={styles.img} />
    }
  }

  return (
    <>
      <section
        className={clsx(styles.section, variantStyle && styles[variantStyle])}
        data-exclude={orderNum}
      >
        <Container className={styles.container}>
          <div className={clsx(styles.secondContainer)}>
            {showImage()}
            <div className={styles.text}>
              {typeof finalTitle === "string" ? (
                <h1 dangerouslySetInnerHTML={{ __html: finalTitle }} />
              ) : (
                <h1>{title}</h1>
              )}
              {typeof description === "string" ? (
                <div dangerouslySetInnerHTML={{ __html: description }} />
              ) : (
                <div>{description}</div>
              )}
            </div>
            <Button
              className={styles.btn}
              onClick={() => handleClickBanner(buttonText, finalTitle)}
            >
              {buttonText}
            </Button>
          </div>
        </Container>
      </section>
      <div
        className={clsx(styles.btnBlock, {
          [styles.hideMobBlock]: isVisible,
          [styles[variantStyle]]: variantStyle,
        })}
      >
        <Container>
          <Button onClick={handleClickStickyBtn} className={styles.mobBtn}>
            {buttonText}
          </Button>
        </Container>
      </div>
    </>
  )
}
